/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  createRoutableExtension,
  createRouteRef,
} from '@backstage/core-plugin-api';
// import { DefaultCatalogPageProps } from './components/CatalogPage';
// import { rootRouteRef } from './routes';
import {
  catalogPlugin,
  DefaultCatalogPageProps,
} from '@backstage/plugin-catalog';
// import { rootRouteRef } from '@backstage/plugin-scaffolder';

export const rootRouteRef = createRouteRef({
  id: 'catalog',
});

/** @public */
export const CustomCatalogIndexPage: (
  props: DefaultCatalogPageProps,
) => JSX.Element = catalogPlugin.provide(
  createRoutableExtension({
    name: 'CustomCatalogIndexPage',
    component: () =>
      import('./components/CustomCatalogPage').then(m => m.CustomCatalogPage),
    mountPoint: rootRouteRef,
  }),
);
